<template>
  <v-container fluid class="pa-6 page-container">
    <SidebarNavigation />

    <!-- Header -->
    <v-card flat class="mb-4">
      <div class="d-flex justify-space-between align-center">
        <div>
          <h2 class="text-h5 font-weight-bold mb-1">
            Generate Description KBB
          </h2>
          <div class="text-body-2 grey--text">
            Upload file Excel draft dan generate description otomatis
          </div>
        </div>

        <v-chip color="primary" outlined>
          Total Data : {{ list.length }}
        </v-chip>
      </div>
    </v-card>

    <!-- Toolbar -->
    <v-card class="pa-4 mb-4" outlined>
      <v-row align="center">
        <v-col cols="12" md="4">
          <v-text-field
            v-model="search"
            label="Cari Data"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
          />
        </v-col>

        <v-col cols="12" md="8">
          <div class="d-flex justify-end align-center">
            <v-file-input
              accept=".xlsx,.xls"
              label="Upload Excel"
              prepend-icon="mdi-file-excel"
              dense
              outlined
              hide-details
              class="upload-field mr-3"
              @change="uploadExcel"
            />

            <v-btn
              color="success"
              elevation="2"
              :disabled="!list.length"
              @click="exportExcel"
            >
              <v-icon left> mdi-file-export </v-icon>
              Export Excel
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- Table -->
    <v-card outlined>
      <v-data-table
        :headers="tableHeaders"
        :items="list"
        :search="search"
        :items-per-page="10"
        dense
        fixed-header
        mobile-breakpoint="0"
        class="professional-table"
      >
        <template v-slot:no-data>
          <div class="py-8 text-center">
            <v-icon size="48" color="grey"> mdi-file-excel-outline </v-icon>

            <div class="mt-2 grey--text">Belum ada data yang diupload</div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <snackbarMessage />
  </v-container>
</template>

<script>
import * as XLSX from "xlsx";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },

  data() {
    return {
      search: "",

      list: [],

      tableHeaders: [
        { text: "Jenis ATK", value: "Jenis ATK", align: "center" },
        { text: "Material", value: "Material", align: "center" },
        { text: "Spesifikasi", value: "Spesifikasi", align: "center" },
        { text: "QTY", value: "QTY", align: "center" },
        { text: "Satuan", value: "Satuan", align: "center" },
        { text: "Departemen", value: "Departemen", align: "center" },
        { text: "Site", value: "Site", align: "center" },
        { text: "Month", value: "Month", align: "center" },
        { text: "Year", value: "Year", align: "center" },
        { text: "HARGA", value: "HARGA", align: "center" },
        { text: "TOTAL (Rp)", value: "TOTAL (Rp)", align: "center" },
        { text: "Vendor", value: "Vendor", align: "center" },
        { text: "KODE ATK", value: "KODE ATK", align: "center" },
        { text: "Description", value: "Description", align: "center" },
      ],
    };
  },

  methods: {
    generateDescription(item) {
      return [
        item["Jenis ATK"],
        item["Material"],
        item["Spesifikasi"],
        `${item["QTY"] || ""} ${item["Satuan"] || ""}`.trim(),
        item["Departemen"],
        item["Site"],
        `${item["Month"] || ""} ${item["Year"] || ""}`.trim(),
        item["Vendor"],
      ]
        .filter(Boolean)
        .join(" # ")
        .toUpperCase();
    },

    uploadExcel(file) {
      console.log(this.user.mst_corporate_id);
      const selectedFile = Array.isArray(file) ? file[0] : file;

      if (!selectedFile) return;

      // Ekstensi yang diperbolehkan
      const allowedExtensions = [".xlsx", ".xls"];
      const fileName = selectedFile.name.toLowerCase();

      const isExcel = allowedExtensions.some((ext) => fileName.endsWith(ext));

      if (!isExcel) {
        store.dispatch("triggerSnackbar", {
          message: "File tidak sesuai !",
          isSuccess: false,
        });

        return;
      }

      const reader = new FileReader();

      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);

        const workbook = XLSX.read(data, {
          type: "array",
        });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const rows = XLSX.utils.sheet_to_json(worksheet, {
          defval: "",
        });

        const cleanedRows = rows.map((row) =>
          Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              key.trim(),
              typeof value === "string" ? value.trim() : value,
            ]),
          ),
        );

        this.list = cleanedRows.map((row) => ({
          ...row,
          Description: this.generateDescription(row),
        }));
      };

      reader.readAsArrayBuffer(selectedFile);
    },

    exportExcel() {
      const exportData = this.list.map((item) => ({
        ...item,
        Description: this.generateDescription(item),
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Generate Description");

      XLSX.writeFile(
        workbook,
        `Generate_Description_KBB_${new Date()
          .toISOString()
          .slice(0, 10)}.xlsx`,
      );
    },
  },

  computed: {
    user() {
      return store.getters["user/getUser"] || {}; // get Data User
    },
  },

  mounted() {
    store.commit("setTitle", "Generate Description KBB");
  },
};
</script>

<style scoped>
.page-container {
  background: #f5f7fb;
  min-height: 100vh;
}

.upload-field {
  max-width: 350px;
}

.professional-table {
  max-height: calc(100vh - 280px);
}

.professional-table ::v-deep thead th {
  background: #f8fafc !important;
  font-weight: 600 !important;
  white-space: nowrap;
}

.professional-table ::v-deep tbody tr:hover {
  background: #f5f9ff !important;
}

.professional-table ::v-deep .v-data-table-header {
  border-bottom: 1px solid #e5e7eb;
}
</style>
